import { ReactElement, ReactNode, useState } from 'react'
import Box from '@mui/material/Box'
import { Modal } from 'components'
import { Typography } from '@mui/material'

interface Props {
  onConfirm(): void
  title?: string
  text?: string
  content?: ReactNode
}

export const confirmModalTextStyles = {
  fontFamily: 'Lato',
  fontWeight: 700,
  fontSize: '22px',
}

const mainBox = {
  padding: '0px 24px',
}

// TODO: move this indo sharable components or in hooks
const useConfirmModal = ({
  onConfirm,
  title,
  text,
  content,
}: Props): [
  ReactElement,
  ({ onProceed }: { onProceed?: VoidFunction }) => void,
] => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const toggleModal = () => setIsOpen(!isOpen)

  const [onProceed, setOnProceed] = useState<VoidFunction>(null)

  const onProceedCallback = () => {
    onProceed()
    toggleModal()
  }
  return [
    <Modal
      isOpen={isOpen}
      onClose={toggleModal}
      title={title}
      onConfirm={onProceed ? onProceedCallback : onConfirm}
    >
      <Box sx={mainBox}>
        {text && <Typography sx={confirmModalTextStyles}>{text}</Typography>}
        {content && content}
      </Box>
    </Modal>,
    (props) => {
      setOnProceed(() => props?.onProceed)
      toggleModal()
    },
  ]
}

export default useConfirmModal
